import global from './spanish-modules/global'
import login from './spanish-modules/login'
import header from './spanish-modules/header'
import sidebar from './spanish-modules/sidebar'
import dashboard from './spanish-modules/dashboard'
import communications from './spanish-modules/communications'
import careCoordinator from './spanish-modules/careCoordinator'
import patient from './spanish-modules/patients'
import appointmentCalendar from './spanish-modules/appointmentCalendar'
import tasks from './spanish-modules/tasks'
import timeTrackingReport from './spanish-modules/timeTrackingReport'
import thresholds from './spanish-modules/thresholds'
import timeLogReport from './spanish-modules/timeLogReport'
import common from './spanish-modules/common'
const spanish = {
    global,
    login,
    header,
    sidebar,
    dashboard,
    communications,
    careCoordinator,
    patient,
    appointmentCalendar,
    tasks,
    timeTrackingReport,
    thresholds,
    timeLogReport,
    common,
}

export default spanish